export enum ReleaseUpdatesRoute {
  RELEASE_UPDATES = 'release-updates'
}
